import { useDelayedLoading } from './useDelayedLoading'
import { useFetchFullURL } from '../utils/useService'

type Args = { fileSource: string; fileName: string };

export function useDownloadFile({ fileSource, fileName }: Args) {

  const {
    startLoading: startDownloadLoading,
    stopLoading: stopDownloadLoading,
    isLoading: isDownloading,
  } = useDelayedLoading();

  async function handleDownload() {
    try {
      startDownloadLoading();

      // using axios as it already saved our auth token in the headers
      const response = await useFetchFullURL(fileSource, {
        method: 'GET',
      });

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } finally {
      stopDownloadLoading();
    }
  }

  return {
    isDownloading,
    handleDownload,
  };
}
